var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.availabilityDate
    ? _c("div", [
        _c("div", { staticClass: "availability-date__txt" }, [
          _vm._v(_vm._s(_vm.availabilityDate))
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }